<template>
  <div class="w-100 d-flex justify-content-center">
    <b-row class="w-100">
      <b-col md="12" style="max-height: 350px; min-height: 50px; overflow-y: auto; background-color: #f9f9f9; padding: 10px; border-radius: 8px; border: 1px solid #ddd;">
        <div v-if="messages.length > 0">
          <div v-for="message in messages" :key="message.planningProductId!==null?message.planningProductId:message.ppSampleId"
             class="message-item"
             style="padding: 5px; margin-bottom: 5px; background-color: white; border-radius: 5px; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); display: flex; justify-content: space-between; align-items: center;">
            <div style="display: flex" class="bottom-block">
              <form-link form="Suppliers" :id="message.fromSupplierId" style="font-size: 12px; width: 200px; text-align: left"><span style="font-weight: bold;">{{ message.fromSupplierLabel }}</span></form-link>
              <form-link form="ProductInSeason" :id="message.productInSeasonId" style="font-size: 12px; width: 350px; text-align: left" class="ml-1 break-line-product">{{ message.productInSeasonLabel }}</form-link>
              <form-link v-if="message.planningProductId" form="PlanningProduct" :id="message.planningProductId" class="break-line" style="font-size: 12px; text-align: left"><span class="ml-1">{{ message.body.slice(0,80) }}
                <span v-if="message.body.length > 80">...</span></span></form-link>
              <form-link v-else-if="message.ppSampleId" form="PPSamplesProduct" :id="message.ppSampleId" class="break-line" style="font-size: 12px; text-align: left"><span class="ml-1">{{ message.body.slice(0,80) }}
                <span v-if="message.body.length > 80">...</span></span></form-link>
              <span style="font-size: 12px; margin-left: auto" class="d-flex align-items-center">{{formatDate(message.orderDate)}}</span>
            </div>
          </div>
        </div>
        <div v-else
             class="message-item"
             style="cursor: pointer; padding: 15px; height: 50px; margin-bottom: 10px; background-color: white; border-radius: 5px; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); display: flex; justify-content: space-between; align-items: center;">
          <span style="font-size: 12px">{{$tr('noNewMess', 'No New Messages')}}</span>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DashletsRpc from "@/DashletsRpc";
import DashletConfig from "@/server/com/silkplm/engine/dashboards/DashletConfig";
import GeneralDashboard from "@/components/dashlets/GeneralDashboard.vue";
import DataGrid2 from "@/components/datagrid/DataGrid2.vue";
import FormLink from "@/components/dashlets/FormLink.vue";
import tr from "@/utils/Tr";

export default {
  name: "UnreadMessages",
  components: {FormLink, DataGrid2, GeneralDashboard},
  async mounted() {
    let x = 5;
  },

  methods: {
    async postprocess(rawMessages) {
      return rawMessages;
    },
    formatDate(date) {
      if(date) {
        const days = [$tr('sunday', 'Sunday'), $tr('monday', 'Monday'), $tr('tuesday', 'Tuesday'),
          $tr('wednesday', 'Wednesday'), $tr('thursday', 'Thursday'), $tr('friday', 'Friday'), $tr('saturday', 'Saturday')];
        const dayName = days[date.getDay()];

        const day = date.getDate().toString().padStart(2, '0');
        const months = [$tr('janu', 'January'), $tr('febru', 'February'), $tr('march', 'March'), $tr('april', 'April'), $tr('may', 'May'), $tr('june', 'June'),
          $tr('july', 'July'), $tr('augu', 'August'), $tr('sept', 'September'), $tr('octo', 'October'), $tr('nove', 'November'), $tr('dec', 'December')];
        const monthName = months[date.getMonth()];

        const year = date.getFullYear();

        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');

        return `${day} ${monthName} ${year}, ${hours}:${minutes}`;
      }
      return null;
    },
  },

  props: {
    uuid: {type: String, required: true},
    messages: {type: [], required: true},
    dashletConfig: {type: DashletConfig},
    config: {type: Object},
    id: {type: Number, required: true},
    selectedMessage: null,
  },

  data() {
    return {
    };
  }
};
</script>

<style scoped>
.message-item {
  height: auto;
}
.break-line {
  width: 450px;
}
.break-line-product {
  width: 300px;
}
.message-item:hover {
  background-color: #f1f1f1;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.15);
}
.bottom-block {
  width: 100%;
}

@media screen and (max-width: 930px) {
  .bottom-block {
    flex-direction: column;
  }
}
@media screen and (max-width: 770px){
  .bottom-block {
    flex-direction: row;
  }
}

@media screen and (max-width: 610px){
  .bottom-block {
    flex-direction: column;
  }
}

@media screen and (max-width: 470px){
  .break-line {
    width: auto;
  }
  .break-line-product {
    width: auto;
  }
}
</style>
